module.exports = __webpack_public_path__ + "img/layout-9_1.a18209da.png";